import {Button, IconButton} from "@mui/material";
import {FiPlus, FiTrash2} from "react-icons/fi";
import {useNavigate} from "react-router-dom";
import ListView from "../components/ListView/ListView";
import Window from "../components/Window/Window";
import {scopesColumns} from "../constants/dataGridColumns";
import useApiRequest from "../hooks/useApiRequest";
import {useEffect} from "react";

const Scopes = () => {
  const navigate = useNavigate();
  const {data, loading, list, remove} = useApiRequest("/scopes");
  useEffect(() => {
    list();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleScopeClick = (scope) => {
    if (!scope?.id) {
      console.error("Error: No se encuentra el scope");
      return;
    }
    navigate(`/scope-form`, {state: {id: scope?.id}});
  };

  const handleRowDelete = async (id) => {
    const confirmDelete = window.confirm("¿Estás seguro de que deseas eliminar este scope?");
    if (confirmDelete) {
      try {
        await remove(id);
        list();
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
      }
    }
  };

  const columns = [
    ...scopesColumns,
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <IconButton
            aria-label="delete"
            color="secondary"
            onClick={(e) => {
              e.stopPropagation();
              handleRowDelete(params.row.id);
            }}
          >
            <FiTrash2 />
          </IconButton>
        );
      }
    }
  ];

  return (
    <Window title={"Scopes"}>
      {loading ? (
        <div style={{textAlign: "center", padding: "20px"}}>
          <span style={{fontSize: "18px", color: "#666"}}>Cargando...</span>
        </div>
      ) : (
        <ListView
          columns={columns}
          data={data}
          loading={loading}
          onRowClick={handleScopeClick}
          TopRigthButtons={
            <Button
              variant="contained"
              color="primary"
              startIcon={<FiPlus />}
              onClick={() => {
                navigate(`/scope-form`);
              }}
            >
              Nuevo Scope
            </Button>
          }
        />
      )}
    </Window>
  );
};

export default Scopes;
